import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-rules-terms',
  templateUrl: './rules-terms.component.html',
  styleUrls: ['./rules-terms.component.scss']
})
export class RulesTermsTecnoComponent implements OnInit {
  constructor(public globalService:GlobalService) { }

  ngOnInit(): void {
  }


}
